import Vue from 'vue'
import App from './App.vue'
// LightBootstrap plugin
import LightBootstrap from './light-bootstrap-main'
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import vSelect from 'vue-select'
import deductTable from './components/DeductTable.vue'


import router from "./router";

Vue.use(LightBootstrap)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.component('v-select', vSelect)
Vue.component('deduct-table', deductTable)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router
})
